import { defineMessages } from 'react-intl';

/** Settings → Account → Sign-in methods. No Claude Design frame: built from the Settings cards. */
export const signInMethodsMessages = defineMessages({
  title: { id: 'app.sml.settings.account.signInMethods.title', defaultMessage: 'Sign-in methods' },
  subtitle: {
    id: 'app.sml.settings.account.signInMethods.subtitle',
    defaultMessage: 'The ways you can sign in to this account. Connect Apple or Google to sign in with one tap.',
  },
  emailCode: { id: 'app.sml.settings.account.signInMethods.emailCode', defaultMessage: 'Email code' },
  emailCodeDetail: {
    id: 'app.sml.settings.account.signInMethods.emailCodeDetail',
    defaultMessage: 'We email a 6-digit code to {email}.',
  },
  emailCodeRelay: {
    id: 'app.sml.settings.account.signInMethods.emailCodeRelay',
    defaultMessage:
      'Your address is an Apple relay address. A code can fail to arrive, so keep Apple or Google connected.',
  },
  apple: { id: 'app.sml.settings.account.signInMethods.apple', defaultMessage: 'Apple' },
  google: { id: 'app.sml.settings.account.signInMethods.google', defaultMessage: 'Google' },
  connected: { id: 'app.sml.settings.account.signInMethods.connected', defaultMessage: 'Connected' },
  alwaysOn: { id: 'app.sml.settings.account.signInMethods.alwaysOn', defaultMessage: 'On' },
  notConnected: {
    id: 'app.sml.settings.account.signInMethods.notConnected',
    defaultMessage: 'Not connected',
  },
  connectedAs: {
    id: 'app.sml.settings.account.signInMethods.connectedAs',
    defaultMessage: 'Signs in as {email}',
  },
  connectedRelay: {
    id: 'app.sml.settings.account.signInMethods.connectedRelay',
    defaultMessage: 'Signs in with a hidden relay address ({email})',
  },
  connect: { id: 'app.sml.settings.account.signInMethods.connect', defaultMessage: 'Connect' },
  connecting: { id: 'app.sml.settings.account.signInMethods.connecting', defaultMessage: 'Connecting…' },
  disconnect: { id: 'app.sml.settings.account.signInMethods.disconnect', defaultMessage: 'Disconnect' },
  lastMethod: {
    id: 'app.sml.settings.account.signInMethods.lastMethod',
    defaultMessage: 'This is your only way to sign in. Connect another one before you disconnect it.',
  },
  nativeHint: {
    id: 'app.sml.settings.account.signInMethods.nativeHint',
    defaultMessage: 'To connect Apple or Google, open Settings in the MUSIC24 app or on music24.com.',
  },
  linked: {
    id: 'app.sml.settings.account.signInMethods.linked',
    defaultMessage: '{provider} is connected. You can now sign in with it.',
  },
  disconnectTitle: {
    id: 'app.sml.settings.account.signInMethods.disconnect.title',
    defaultMessage: 'Disconnect {provider}?',
  },
  disconnectDescription: {
    id: 'app.sml.settings.account.signInMethods.disconnect.description',
    defaultMessage:
      'You can no longer sign in with {provider} as {email}. Your account, your workspaces and your data stay. You can connect it again at any time.',
  },
  disconnectCancel: { id: 'app.sml.settings.account.signInMethods.disconnect.cancel', defaultMessage: 'Cancel' },
  errorIdentityTaken: {
    id: 'app.sml.settings.account.signInMethods.error.identityTaken',
    defaultMessage:
      'This {provider} account already signs in to another MUSIC24 account. Sign in there and disconnect it first. We do not merge accounts.',
  },
  errorProviderConnected: {
    id: 'app.sml.settings.account.signInMethods.error.providerConnected',
    defaultMessage: 'You already connected a {provider} account. Disconnect it first.',
  },
  errorState: {
    id: 'app.sml.settings.account.signInMethods.error.state',
    defaultMessage: 'This connect attempt expired. Try again.',
  },
  errorProof: {
    id: 'app.sml.settings.account.signInMethods.error.proof',
    defaultMessage: 'We could not verify the {provider} sign-in. Try again.',
  },
  errorCancelled: {
    id: 'app.sml.settings.account.signInMethods.error.cancelled',
    defaultMessage: 'The {provider} window closed before the sign-in ended.',
  },
  errorUnavailable: {
    id: 'app.sml.settings.account.signInMethods.error.unavailable',
    defaultMessage: '{provider} sign-in is not available right now. Try again later.',
  },
  errorLastMethod: {
    id: 'app.sml.settings.account.signInMethods.error.lastMethod',
    defaultMessage: 'This is your only way to sign in. Connect another one first.',
  },
  errorGeneric: {
    id: 'app.sml.settings.account.signInMethods.error.generic',
    defaultMessage: 'Something went wrong. Try again.',
  },
});
